import { render, staticRenderFns } from "./AddedToCartProduct.vue?vue&type=template&id=0526ab27&scoped=true"
import script from "./AddedToCartProduct.vue?vue&type=script&lang=ts"
export * from "./AddedToCartProduct.vue?vue&type=script&lang=ts"
import style0 from "./AddedToCartProduct.vue?vue&type=style&index=0&id=0526ab27&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0526ab27",
  null
  
)

export default component.exports